import range from 'lodash/range'

import Skeleton from '@mui/material/Skeleton'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@components/_mui/Typography'

import usePageParams from '@shared/hooks/src/usePageParams'

import Item from '@components/TableCell/Item'

export default function TableLoader({ columns, double = false, items: overridePerPage, typography = {} }) {
  const [, perPage] = usePageParams()

  return range(0, overridePerPage || perPage).map((i) => (
    <TableRow key={i}>
      {range(columns).map((i) => (
        <TableCell key={i}>
          {double ? (
            <Item.Loading />
          ) : (
            <Typography {...typography}>
              <Skeleton />
            </Typography>
          )}
        </TableCell>
      ))}
    </TableRow>
  ))
}
